import { sendFileRequest, apiRequest, putApiRequest } from './_tools';

export function fetchPaymentDetails({ page, itemsPerPage, sort, role, filter }) {
  return apiRequest(`/api/paymentsWithPaging?page=${page}` +
    `&itemsPerPage=${itemsPerPage}` +
    `&role=${role}` +
    `&period=${filter.period}` +
    `&publisherName=${filter.publisherName}` +
    `&publisherEmail=${filter.publisherEmail}` +
    `&publisherId=${filter.publisherId}` +
    `&publisherExternalId=${filter.publisherExternalId}` +
    `&status=${filter.status}` +
    `&paymentMethod=${filter.paymentMethod}` +
    `&paypalEmail=${filter.paypalEmail}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchPaymentsTotalBalance() {
  return apiRequest('/api/payments/balance')
    .catch(({ error }) => Promise.reject(error));
}

export function setPaymentPaid({ externalId, status }) {
  return putApiRequest(`/api/payments/${externalId}/pay`, { status })
    .catch((error) => console.log(error, error.stack));
}

export function refreshBalance({ period }) {
  return putApiRequest('/api/payments/refresh', { period })
    .catch((error) => console.log(error, error.stack));
}

export function getPeriods() {
  return apiRequest('/api/payments/periods')
    .catch((error) => console.log(error, error.stack));
}

export function getLastRefreshDate() {
  return apiRequest('/api/payments/refreshDate')
    .catch((error) => console.log(error, error.stack));
}

export function getNextPaymentCycle() {
  return apiRequest('/api/payments/nextCycle')
    .catch((error) => console.log(error, error.stack));
}

export function processPayments({ file, process }) {
  return sendFileRequest(`/api/payments/process/${process}`, file)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/payments.js
 **/